import React from 'react';
import classnames from 'classnames';
import overlayStyles from './OverlayHelpers.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  /** Do not take up layout space when not visible */
  collapseWhenHidden?: boolean;
  /** Work opposite - show only when not hovered */
  reverseHidden?: boolean;
}

const HoverOnly = React.forwardRef<HTMLDivElement, Props>(
  (
    { collapseWhenHidden, reverseHidden, children, className, ...props },
    ref
  ) => (
    <div
      ref={ref}
      className={classnames(
        overlayStyles[
          `hover-${reverseHidden ? 'hidden' : 'only'}${
            collapseWhenHidden ? '-and-collapsed' : ''
          }`
        ],
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
);
HoverOnly.displayName = 'HoverOnly';

export default HoverOnly;
